import { faCheck, faCopy } from '@fortawesome/pro-regular-svg-icons';
import React, { useState } from 'react';
import { Icon } from 'src/components/Icon';
import { IconButton } from 'src/components/IconButton';
import toast from 'src/utils/toast';

interface CopyToClipboardProps {
  text: string;
  onCopy?: () => void;
  children?: React.ReactNode;
}

export const CopyToClipboard: React.FC<CopyToClipboardProps> = ({
  text,
  onCopy,
  children,
}) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      toast.success('Copied to clipboard');
      onCopy?.();
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      toast.error('Failed to copy to clipboard');
    }
  };

  return children ? (
    <div onClick={handleCopy}>{children}</div>
  ) : (
    <IconButton onClick={handleCopy}>
      {copied ? (
        <Icon icon={faCheck} />
      ) : (
        <Icon icon={faCopy} />
      )}
    </IconButton>
  );
};
